Ext.define('SA.HistoricalModeIndicator', {
    singleton: true,

    maybeShow(model) {
        if (!model.hasHistoricalCensusRelease()) {
            SA.ModeIndicator.set({visible: false, text: ''});
            return;
        }

        SA.ModeIndicator.set({
            visible: true,
            text: `Historical Data & Locations: ${model.getCensusReleaseRange().join(' to ')} Census Geographies`
        });
    }
});